import { api } from './authService';

export interface PendenteEntry {
  id: string;
  date: string;
  payee: string;
  postings: { account: string; amount: number; commodity: string }[];
  tags: Record<string, string>;
  file: string;
  doc_count?: number;
}

export interface PendentesResponse {
  pendentes: PendenteEntry[];
  summary: { Receitas: number; Despesas: number; Ativos: number; Passivo: number };
  total: number;
}

export async function listPendentes(): Promise<PendentesResponse> {
  const res = await api.get<PendentesResponse>('/pendentes');
  return res.data;
}

export async function promotePendente(
  xactId: string,
  replacements: Record<string, string>,
): Promise<unknown> {
  const res = await api.post(`/pendentes/${encodeURIComponent(xactId)}/promote`, {
    replacements,
  });
  return res.data;
}

export const SUSPENSE_ACCOUNTS = [
  'Receitas:Pendente',
  'Despesas:Pendente',
  'Ativos:Pendente',
  'Passivo:Pendente',
];

export function isSuspenseAccount(account: string): boolean {
  return SUSPENSE_ACCOUNTS.includes(account);
}
